import React from "react";
import { useSelector } from "react-redux";
import PaymentInstrumentDefinedAmount from "./PaymentInstrument";
import PaymentInstrumentPartialAmount from "./PaymentInstrumentPA";
import Wallet from "./Wallet";
import CorporateCredit from "./CorporateCredit";

export default function PaymentMethods(props: { isPreview?: boolean }) {
  const cart = useSelector((state) => state.cart);
  const totalToPayFromCorporateCredit = cart?.totalToPayFromCorporateCredit;
  const totalToPayFromWallet = cart?.totalToPayFromWallet;
  const totalToPay = cart?.totalToPay;

  if (!cart) return null;

  return (
    <div style={{ margin: "0 0 8px" }}>
      {totalToPayFromCorporateCredit > 0 && <CorporateCredit />}
      {totalToPayFromWallet > 0 && <Wallet />}
      {totalToPay > 0 && <PaymentInstrumentPartialAmount />}
      {totalToPay > 0 && (
        <PaymentInstrumentDefinedAmount isPreview={props.isPreview} />
      )}
    </div>
  );
}
